import Alpine from '/src/app.js';
import galleryMaps from './gallery-maps';

Alpine.plugin(galleryMaps);
Alpine.start();
